// src/api/orders.js
import client from './client.js';

export const ordersAPI = {
  getAll: (params) => client.get('/orders', { params }),
  getMy: (params) => client.get('/orders/my', { params }),
  getById: (id) => client.get(`/orders/${id}`),
  // Публичный трекер для ГОСТЯ. Админский `getById` гостю недоступен (403),
  // поэтому после оформления без регистрации ведём сюда.
  // Для подтверждения владения сервер требует email ИЛИ телефон,
  // указанные при оформлении (см. getPublicOrder в orderController.js).
  getPublic: (id, params) => client.get(`/orders/public/${id}`, { params }),
  getPublicByNumber: (orderNumber, params) =>
    client.get(`/orders/public/number/${orderNumber}`, { params }),
  create: (data) => client.post('/orders', data),
  updateStatus: (id, data) => client.put(`/orders/${id}/status`, data),
  updatePayment: (id, data) => client.put(`/orders/${id}/payment`, data),
};